import { AdminAccountSummary } from './AdminAccountSummary';
import { AdminNavLinks } from './AdminNavLinks';

export const AdminNavbar = ({ activeRoute, currentUser, onLogout, onNavigate }) => (
  <aside className="col-12 col-md-3 col-lg-2 admin-nav">
    <div className="admin-nav-mobile-header">
      <img className="admin-nav-logo" src="./logo.png" alt="Photociancio" />
      <button
        className="navbar-toggler add-btn btn"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#adminNav"
        aria-controls="adminNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i className="bi bi-list" />
      </button>
    </div>

    <div className="collapse navbar-collapse admin-nav-collapse" id="adminNav">
      <div className="admin-nav-content">
        <div>
          <AdminAccountSummary currentUser={currentUser} />
          <AdminNavLinks activeRoute={activeRoute} currentUser={currentUser} onNavigate={onNavigate} />
        </div>

        <button className="btn btn-danger w-100 admin-logout-button" type="button" onClick={onLogout}>
          <i className="bi bi-box-arrow-right me-2" />
          Logout
        </button>
      </div>
    </div>
  </aside>
);
